import { Reveal } from "./Reveal";

const BENEFITS = [
  { emoji: "📚", bg: "#EDDFCB", title: "Biblioteca de guías",   text: "PDFs por tema con badge de novedades, siempre a mano." },
  { emoji: "🧩", bg: "#D9E4DA", title: "Material de apoyo",      text: "Plantillas, ejercicios y material didáctico descargable." },
  { emoji: "🌱", bg: "#EDDFCB", title: "A tu ritmo",              text: "Contenido asincrónico, sin presión, cuando lo necesites." },
];

export function Solucion() {
  return (
    <div className="container" style={{ paddingTop: 78, paddingBottom: 20 }}>
      <Reveal>
        <div style={{ textAlign: "center", marginBottom: 40 }}>
          <h2 className="section-title-display fluid-heading-md solucion-title" style={{ marginBottom: 10 }}>
            Todo tu bienestar, acompañado
          </h2>
          <p className="mobile-text-md" style={{ color: "var(--muted)", margin: 0 }}>Una membresía gratuita que crece contigo.</p>
        </div>
      </Reveal>

      <div className="grid-3">
        {BENEFITS.map((b, i) => (
          <Reveal key={b.title} delay={(i % 4) as 0 | 1 | 2 | 3}>
            <div className="card card--hover" style={{ padding: 30, height: "100%" }}>
              <div style={{
                width: 52, height: 52, borderRadius: 16, background: b.bg,
                display: "flex", alignItems: "center", justifyContent: "center", fontSize: 25, marginBottom: 18,
              }} className="icon-pop">
                {b.emoji}
              </div>
              <div style={{ fontFamily: "var(--font-display)", fontWeight: 700, fontSize: 20, marginBottom: 7 }}>{b.title}</div>
              <div style={{ fontSize: 15, color: "var(--muted)", lineHeight: 1.55 }}>{b.text}</div>
            </div>
          </Reveal>
        ))}
      </div>
    </div>
  );
}
